export const renameProperty = (obj, oldName, newName) => {
    const copyOfObj = {...obj};
    copyOfObj[newName] = copyOfObj[oldName];
    delete copyOfObj[oldName];
    return copyOfObj;
};

